import { useNavigate, useLocation } from "react-router-dom";
import { Info } from "lucide-react";
import { V3Page, V3Aside, V3Actions, Field } from "@/components/control/v3";

// C20: unknown address – clear error state instead of a silent redirect.
export default function NotFound() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  return (
    <V3Page crumb="Übersicht" title="Fehler, Rechte und Bestätigungen" subtitle="Für diese Adresse gibt es keinen Bereich in Control OS."
      aside={<V3Aside subject="Aufgerufene Adresse" />} testId="not-found-page">
      <div className="flex items-center gap-3 rounded-xl border border-[#F6E3B4] bg-[#FFF6DD] px-4 py-5" role="alert">
        <Info className="h-8 w-8 shrink-0 text-brand-purple" aria-hidden="true" />
        <div><p className="text-lg font-bold text-brand-purple">Seite nicht gefunden</p><p className="text-sm text-zinc-600">Es wurde nichts geändert.</p></div>
      </div>
      <Field label="Vorgang" testId="not-found-path">{pathname}</Field>
      <Field label="Status">Nicht vorhanden</Field>
      <Field label="Zugriff">Aktuelle Berechtigung erneut prüfen</Field>
      <Field label="Nächster Schritt">Zum erlaubten Bereich zurückkehren</Field>
      <V3Actions primary="Zur Übersicht" onPrimary={() => navigate("/")} secondary="Zurück" onSecondary={() => navigate(-1)} testId="not-found" />
    </V3Page>
  );
}
